import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    states: [],
    dealerships: [],
    brand_new_models: []
  },
  actions: {
    async getStates({ commit }) {
      let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/search-vehicle/brand-new/car-dealership/states`)
      sessionStorage.setItem('states', JSON.stringify(data))
      commit('setStates', sessionStorage.getItem('states'))
    },
    async getDealerships({ commit }, stateId) {
      let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/search-vehicle/brand-new/car-dealerships?state_id=${stateId}`)
      sessionStorage.setItem('dealerships', JSON.stringify(data))
      commit('setDealerships', sessionStorage.getItem('dealerships'))
    },
    async getBrandNewModels({ commit }, $dealershipId) {
      let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/search-vehicle/brand-new/car-dealership/models?dealership_id=${$dealershipId}`)
      sessionStorage.setItem('brand_new_models', JSON.stringify(data.data))
      commit('setBrandNewModels', sessionStorage.getItem('brand_new_models'))
    }
  },
  mutations: {
    setStates(state, data) {
      state.states = JSON.parse(data)
    },
    setDealerships(state, data) {
      state.dealerships = JSON.parse(data)
    },
    setBrandNewModels(state, data) {
      state.brand_new_models = JSON.parse(data)
    },
  }
}
